const map = {
	"./default/default-favicon.png": 85115,
	"./default/digitransit-logo.png": 82637,
	"./default/nearby-stop_animation.gif": 73197,
	"./default/nearby-stop_desktop-animation.gif": 68710,
	"./hameenlinna/hameenlinna-favicon.png": 75987,
	"./hameenlinna/hameenlinna-logo.png": 15678,
	"./hsl/geolocation.svg": 63280,
	"./hsl/hsl-favicon.png": 88591,
	"./hsl/navigator-logo.svg": 15075,
	"./hsl/not-found.svg": 3970,
	"./hsl/reittiopas-logo.svg": 44442,
	"./hsl/thumbs-up.svg": 24825,
	"./hsl/traffic-light.svg": 34954,
	"./hsl/trafficnow-header.svg": 24303,
	"./joensuu/joensuu-favicon.png": 23943,
	"./joensuu/jojo-logo-secondary.svg": 58879,
	"./joensuu/jojo-logo.png": 64205,
	"./jyvaskyla/jyvaskyla-favicon.png": 7879,
	"./kotka/kotka.png": 10084,
	"./kouvola/kouvola-favicon.png": 97303,
	"./kouvola/logo.png": 5598,
	"./kouvola/secondary-logo.png": 56869,
	"./kuopio/kuopio-favicon.png": 24735,
	"./kuopio/kuopio-secondary-logo.png": 93873,
	"./kuopio/logo.png": 48532,
	"./lahti/lahti-favicon.png": 70635,
	"./lahti/lahti-logo.png": 74694,
	"./lahti/secondary-lahti-logo.png": 79929,
	"./lappeenranta/lappeenranta-favicon.jpg": 16167,
	"./lappeenranta/logo.png": 40914,
	"./lappeenranta/secondary-logo.png": 36177,
	"./matka/matka-favicon.svg": 87608,
	"./matka/matka-logo-secondary.svg": 51296,
	"./matka/matka-logo.svg": 71413,
	"./oulu/oulu-favicon.png": 64671,
	"./oulu/oulu-logo.png": 26226,
	"./oulu/secondary-oulu-logo.png": 14443,
	"./pori/pori-favicon.png": 2773,
	"./pori/pori_logo.svg": 14837,
	"./raasepori/raasepori-favicon.png": 80279,
	"./raasepori/raasepori_logo_musta.png": 93665,
	"./raasepori/raasepori_logo_valkoinen.png": 57894,
	"./rovaniemi/rovaniemi-favicon.png": 55467,
	"./rovaniemi/rovaniemi-logo.svg": 44465,
	"./tampere/tampere-favicon.png": 57031,
	"./tampere/tampere-logo.png": 2442,
	"./turku/foli-logo.png": 68249,
	"./turku/turku-favicon.png": 24423,
	"./vaasa/vaasa-favicon.png": 4987,
	"./vaasa/vaasa-secondary-logo.png": 81213,
	"./varely/seutuplus-logo-white.svg": 67318,
	"./varely/seutuplus-logo.svg": 70842,
	"./varely/varely-favicon.png": 48383,
	"./walttiOpas/waltti-logo-secondary.png": 518,
	"./walttiOpas/waltti-logo.png": 44412,
	"./walttiOpas/walttiOpas-favicon.png": 75673
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54061;